var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.entity
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new": false,
              "show-delete": _vm.entity.isActive && !_vm.entity.isNew,
              "show-print": !_vm.entity.isNew,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("app-side-menu", [
                  _c(
                    "aside",
                    {
                      staticClass: "menu",
                      attrs: { slot: "side-menu" },
                      slot: "side-menu",
                    },
                    [
                      _c("p", { staticClass: "menu-label" }, [
                        _c("span", { staticClass: "title is-6" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.entity.firstName
                                  ? _vm.entity.firstName
                                  : "Name"
                              ) +
                                " " +
                                _vm._s(_vm.entity.lastName)
                            ),
                          ]),
                        ]),
                      ]),
                      _c("ul", { staticClass: "menu-list" }, [
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.routeTypes.ContactDetail.name,
                                    query: _vm.$route.query,
                                  },
                                  "active-class": "is-active",
                                  exact: "",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                        _vm.$v.detailGroup.$error,
                                    },
                                    attrs: {
                                      "data-badge": _vm.$v.detailGroup.$error
                                        ? ""
                                        : null,
                                    },
                                  },
                                  [_vm._v(" Detail Info ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.routeTypes.ContactAsset.name,
                                    query: _vm.$route.query,
                                  },
                                  "active-class": "is-active",
                                  append: "",
                                },
                              },
                              [_vm._v("Links")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.routeTypes.ContactAddress.name,
                                    query: _vm.$route.query,
                                  },
                                  "active-class": "is-active",
                                  append: "",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                        _vm.$v.addressesGroup.$error,
                                    },
                                    attrs: {
                                      "data-badge": _vm.$v.addressesGroup.$error
                                        ? ""
                                        : null,
                                    },
                                  },
                                  [_vm._v(" Addresses ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.routeTypes.ContactPhoneEmail.name,
                                    query: _vm.$route.query,
                                  },
                                  "active-class": "is-active",
                                  append: "",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                        _vm.$v.emailsPhonesGroup.$error,
                                    },
                                    attrs: {
                                      "data-badge": _vm.$v.emailsPhonesGroup
                                        .$error
                                        ? ""
                                        : null,
                                    },
                                  },
                                  [_vm._v(" Phones/Emails ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.routeTypes.ContactRemark.name,
                                    query: _vm.$route.query,
                                  },
                                  "active-class": "is-active",
                                  append: "",
                                },
                              },
                              [_vm._v("Remarks")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("router-view", {
                  attrs: { entity: _vm.entity },
                  on: { toggleActive: _vm.onToggleActive },
                }),
              ],
              1
            ),
          ]),
          _c(
            "unsaved-modal",
            {
              attrs: { active: _vm.isUnsavedModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isUnsavedModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                skipSave: function ($event) {
                  return _vm.skipSave()
                },
                saveContinue: function ($event) {
                  return _vm.saveContinue()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Unsaved Changes"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "There are unsaved changes. Please select action below"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "save-conflict-modal",
            {
              attrs: { active: _vm.isSaveConflictModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isSaveConflictModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                reload: function ($event) {
                  return _vm.reloadData()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Change conflict"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "The data on the server is newer than the local copy. Please reload local data."
                  ),
                ]
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isDeleteConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isDeleteConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(false, false, _vm.deleteAndSave)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false, true, false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Contact is in use"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(_vm.entity.firstName) +
                          " " +
                          _vm._s(_vm.entity.lastName)
                      ),
                    ]
                  ),
                  _vm._v(" is in use. Set to "),
                  _c("span", { staticClass: "tag is-danger" }, [
                    _vm._v("In-Active"),
                  ]),
                  _vm._v(" anyway? "),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }